/**
 * Data access for the GCP Monitoring dashboard (DEV-6080).
 *
 * Reuses `fetchWithFallback` from the OrgUsageAnalytics page, which already
 * handles the double `/admin` prefix, the `userId` auth query param, and the
 * prod/dev endpoint fallback. Every endpoint is mounted under
 * `/admin/gcp-monitoring/*` on the backend.
 */

import { fetchWithFallback } from "../OrgUsageAnalytics/api";

/**
 * One-shot fetch: ranked findings plus all four panel datasets and any
 * per-panel errors. The backend fans out to the four services with a short
 * in-memory cache, so this keeps the page to a single request.
 *
 * @param {string} window - 1h | 6h | 24h | 7d
 * @param {string} env - prod | dev
 * @param {boolean} [refresh] - bypass the backend cache
 */
export const fetchDiagnosis = (window, env, refresh = false) =>
  fetchWithFallback(
    "/gcp-monitoring/diagnosis",
    { window, ...(refresh ? { refresh: "true" } : {}) },
    { env, timeoutMs: 90000 },
  );

// Individual panel endpoints — not used by the default page load (the
// diagnosis call returns everything) but available for targeted refetches.
export const fetchMemory = (window, env) =>
  fetchWithFallback("/gcp-monitoring/memory", { window }, { env });

export const fetchQueues = (window, env) =>
  fetchWithFallback("/gcp-monitoring/queues", { window }, { env });

export const fetchErrors = (window, env) =>
  fetchWithFallback("/gcp-monitoring/errors", { window }, { env });

export const fetchRootCauses = (window, env) =>
  fetchWithFallback("/gcp-monitoring/root-causes", { window }, { env });
